angular.module('storefrontApp')
    .controller('orderController', ['$scope', '$window', 'orderService', 'catalogService', 'googleAnalyticsService',
        function ($scope, $window, orderService, catalogService, googleAnalyticsService) {
            getOrder($window.orderNumber);

            function getOrder(orderNumber) {
                orderService.getOrder(orderNumber)
                    .then(function (response) {
                        if (response && response.data) {
                            $scope.order = response.data;

                            $scope.orderNumber = $scope.order.number;
                            $scope.isShowPayment = false;

                            const lastPayment = _.last(_.sortBy($scope.order.inPayments, 'createdDate'));

                            $scope.billingAddress = (lastPayment && lastPayment.billingAddress)
                                || _.findWhere($scope.order.addresses, {
                                    type: 'billing',
                                })
                                || _.first($scope.order.addresses);

                            const productsIds = _.map($scope.order.items, (x) => x.productId);

                            catalogService.getProducts(productsIds)
                                .then(function ({ data }) {
                                    _.each($scope.order.items, function (item) {
                                        item.product = {};
                                        item.product.variationProperties = _.find(
                                            data,
                                            (x) => x.id === item.productId,
                                        ).variationProperties;
                                    });
                                });

                            googleAnalyticsService.purchase($scope.order);
                        }
                    });
            }
        },
    ]);
